<ng-template #content>
    <div
        class="o-tabs__content__pane"
        [attr.id]="'content-' + id"
        [attr.aria-labelledby]="'nav-' + id"
        tabindex="0"
        role="tabpanel"
    >
        <ng-content></ng-content>
    </div>
</ng-template>
